"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SegmentedControl", {
  enumerable: true,
  get: function get() {
    return _SegmentedControl.default;
  }
});

var _SegmentedControl = _interopRequireDefault(require("./src/SegmentedControl"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zZWdtZW50ZWQtY29udHJvbC9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7OztBQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCBhcyBTZWdtZW50ZWRDb250cm9sIH0gZnJvbSAnLi9zcmMvU2VnbWVudGVkQ29udHJvbCdcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/segmented-control/index.js
// module id = 184
// module chunks = 0